
import type { RegularFilterValueConfig } from '@empathybroker/tsclient-play/dist/models/instance/filters/regular-filter-value-config'
import type { RankingElement } from '@empathybroker/tsclient-play/dist/models/ranking-element'
import type { PropType } from 'vue'
import type { RegularFilter, RegularFilterConfig, RegularFilterSelectedValues } from '../../models'
import { deepMerge } from '@empathyco/x-deep-merge'

import Vue, { defineComponent } from 'vue'

import { PositionEnum } from '../../enums'

import EpbAside from '../aside.component.vue'
import Schedule from '../crud/schedule.component.vue'
import RegularFilterSelector from '../filters/regular-filter-selector.component.vue'
import { EpbButton } from '../shared/epb-button'

export default defineComponent({
  name: 'RankingElementAside',
  components: {
    EpbAside,
    RegularFilterSelector,
    Schedule,
    EpbButton,
  },
  props: {
    element: {
      type: Object as PropType<RankingElement>,
      required: true,
    },
    filterConfigs: {
      type: Array as PropType<Array<RegularFilterConfig>>,
      required: true,
    },
    messages: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editingElement: undefined,
      PositionEnum,
    }
  },
  computed: {
    filters(): RegularFilter[] {
      return this.filterConfigs.map((filterConfig: RegularFilterConfig) => ({
        config: filterConfig,
        selectedValues: this.getFilterSelectedValues(filterConfig),
      }))
    },
  },
  watch: {
    element: {
      handler(): void {
        this.editingElement = deepMerge({}, this.element)
        this.editingElement.schedule = Object.assign(
          {
            activationDate: undefined,
            deactivationDate: undefined,
          },
          this.element.schedule,
        )
      },
      immediate: true,
    },
  },
  methods: {
    getFilterSelectedValues(filterConfig: RegularFilterConfig): RegularFilterSelectedValues {
      const filterId = filterConfig.toolingId || filterConfig.id
      let elementFilterValues: string[] | string
      if (this.editingElement.filters) {
        elementFilterValues = this.editingElement.filters[filterId]
      }
      if (!Array.isArray(elementFilterValues)) {
        elementFilterValues = elementFilterValues ? [elementFilterValues] : []
      }
      return elementFilterValues.map((elementFilterValue: string) => {
        const elementFilterValueConfig = filterConfig.values.find(
          (valueConfig: RegularFilterValueConfig) =>
            (valueConfig.taggingId || valueConfig.id) === elementFilterValue,
        )
        return (!!elementFilterValueConfig && elementFilterValueConfig.id) || elementFilterValue
      })
    },
    onFilterChange(filter: RegularFilter, selectedValues: RegularFilterSelectedValues): void {
      let elementFilterValues: string[] | string = selectedValues.map((selectedValue: string) => {
        const selectedValueConfig = filter.config.values.find(
          (valueConfig: RegularFilterValueConfig) => valueConfig.id === selectedValue,
        )
        return selectedValueConfig.taggingId || selectedValueConfig.id
      })
      if (filter.config.multiselectDisabled) {
        elementFilterValues = elementFilterValues[0]
      }
      Vue.set(
        this.editingElement.filters,
        filter.config.toolingId || filter.config.id,
        elementFilterValues,
      )
    },
    onAccept(): void {
      this.$emit('updateElement', this.editingElement)
      this.$emit('close')
    },
  },
})
